<template>
    <div class="card">
        <div class="card-header p-2">
            <div class="row">
                <div class="col-md-10 d-flex align-items-center">
                    <strong>{{ 'Partners > Contacts' }}</strong>
                </div>
                <div class="col-md-2">
                    <goback></goback>
                </div>
            </div>
        </div>
        <div class="p-2">
            <table class="custom-table fonts11" style="table-layout: fixed;">
                <tr>
                    <div class="table-responsive app" v-dragscroll="true">
                        <table id="s1s-sector" class="table table-bordered app-inner mb-0" style="font-size: 11px;">
                            <thead style="width: 99.5%;" v-if="tableFields.length > 0">
                                <tr>
                                    <th class="text-center p-1" style="width: 50px;">Index</th>
                                    <th class="align-middle p-1" v-for="(lblObj, lIdx) in tableFields">
                                        {{ lblObj.title }}</th>
                                    <th class="text-center p-1" style="width: 50px;">Edit</th>
                                </tr>
                            </thead>
                            <tbody v-if="tableFields.length > 0">
                                <tr v-for="(row, index, key) in contactList" v-bind:key="'row' + row + index">
                                    <td class="text-center p-1" style="width: 50px;">{{ index + 1 }}</td>
                                    <td class="p-1" v-for="(fieldObj, ind) in tableFields"
                                        v-bind:key="ind + '-td-' + index + key">
                                        <span>
                                            {{ row[fieldObj.field] }}
                                        </span>
                                    </td>
                                    <td class="text-center p-1" style="width: 55px;"><a class="btn-primary btn-edit"
                                            @click.prevent="editCompany(row, index)">
                                            <i :title="'Edit'" class="fa fa-edit cwhite"></i>
                                        </a></td>
                                </tr>
                            </tbody>
                            <tfoot v-if="contactList.length === 0">
                                <tr>
                                    <td :colspan="tableFields.length">
                                        <div class="alert alert-danger" role="alert">No data found!
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </tr>
            </table>
        </div>
        <!-- Modal -->
        <div class="modal-overlay" v-if="editContactOpen">
            <div class="modal-content">
                <h4>Edit Contact</h4>
                <span class="close-btn" @click="closeEditContactModal">&times;</span>
                <div class="m-4">
                    <form class="form-horizontal" @onsubmit.prevent action>
                        <div class="cat-form">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group text-left"
                                        :class="{ 'has-error': validation.hasError('selectedEditItem.name') }">
                                        <label class="form-control-label">Name</label>
                                        <input type="text" class="form-control " placeholder="Name" value
                                            v-model="selectedEditItem.name" />
                                        <div class="error">{{ validation.firstError('selectedEditItem.name') }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group text-left"
                                        :class="{ 'has-error': validation.hasError('selectedEditItem.email') }">
                                        <label for="select-category" class="form-control-label">Email</label>
                                        <input type="text" class="form-control " placeholder="Email" value
                                            v-model="selectedEditItem.email" />
                                        <div class="error">{{ validation.firstError('selectedEditItem.email') }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group text-left"
                                        :class="{ 'has-error': validation.hasError('selectedEditItem.phone') }">
                                        <label class="form-control-label">Phone</label>
                                        <input type="text" class="form-control " placeholder="Phone" value
                                            v-model="selectedEditItem.phone" />
                                        <div class="error">{{ validation.firstError('selectedEditItem.phone') }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group text-left"
                                        :class="{ 'has-error': validation.hasError('selectedEditItem.whatsapp') }">
                                        <label class="form-control-label">Whatsapp</label>
                                        <input type="text" class="form-control " placeholder="whatsapp" value
                                            v-model="selectedEditItem.whatsapp" />
                                        <div class="error">{{ validation.firstError('selectedEditItem.whatsapp') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="raw">
                                <div class="col-md-12" v-if="errors && errors.length > 0">{{ errors }}</div>
                            </div>
                            <div class="w-full d-flex justify-content-center">
                                <button type="button" @click="submitHandler" class="btn btn-info">Update</button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
export default {
    components: {},
    name: "Contacts",
    mixins: [commonMixins],
    created() {
        this.fetchContentList();
    },
    data() {
        return {
            errors: [],
            categoryList: [],
            curTab: "",
            tableFields: [
                { title: "Name", field: "name" },
                { title: "Email", field: "email" },
                { title: "Whatsapp", field: "whatsapp" },
                { title: "Phone", field: "phone" },
            ],
            //name: "", phone: "", email: "", whatsapp: "",
            contactList: [],
            editContactOpen: false,
            selectedEditIndex: -1,
            selectedEditItem: { name: "", phone: "", email: "", whatsapp: "", "_id": "", "user_id": "" },
        };
    },
    validators: {
        'selectedEditItem.name': function (value) {
            return Validator.value(value).required('Name is required');
        },
        'selectedEditItem.phone': function (value) {
            return Validator.value(value)
                .required('Phone number is required')
                .regex(/^\+91\d{10}$/, 'Phone number must be valid with country code')
            //.regex(/^\+?[1-9]\d{9,14}$/, 'Phone number must be valid with country code');
        },
        'selectedEditItem.email': function (value) {
            return Validator.value(value).required('Email is required').email();
        },
        'selectedEditItem.whatsapp': function (value) {
            return Validator.value(value)
                .required('WhatsApp number is required')
                .regex(/^\+91\d{10}$/, 'WhatsApp number must be valid with country code');
        },
    },
    methods: {
        Validator() {
            return Validator.create();
        },
        clearForm() {
            this.selectedEditItem = {
                name: "",
                phone: "",
                email: "",
                whatsapp: "",
                _id: "",
                user_id: ""
            };
            this.selectedEditItem = {}
            this.error = [];
            this.validation.reset();
        },
        closeEditContactModal() {
            console.log('this', this.editContactOpen);
            this.clearForm();
            // this.selectedEditItem = { name: "", phone: "", email: "", whatsapp: "", "_id": "", "user_id": "" };
            this.editContactOpen = false;
        },
        editCompany(select, index) {
            console.log('>>> editCompany', select, index);
            this.selectedEditIndex = index;
            //this.selectedEditItem = { name: "", phone: "", email: "", whatsapp: "", "_id": "", "user_id": "" };
            const deepClone = JSON.parse(JSON.stringify(select));
            this.selectedEditItem = deepClone;
            this.editContactOpen = true;
            /*  this.name = 
             phone: "",
             email: "",
             whatsapp: "", */
            //this.contactList[index].selected = select;
        },
        submitHandler() {
            let self = this;
            this.$validate(["selectedEditItem.name", "selectedEditItem.email", "selectedEditItem.phone", "selectedEditItem.whatsapp"]).then(success => {
                console.log('on success >>>' + success)
                if (success) {

                    console.log('self.selectedEditItem >>>', self.selectedEditItem);
                    /* console.log('self.email >>>', self.selectedEditItem);
                    console.log('self.email >>>', self.email);
                    console.log('self.whatsapp >>>', self.whatsapp); */
                    http.post("/frontend/contacts/update", self.selectedEditItem, function (
                        error,
                        response
                    ) {
                        if (!error) {
                            console.log("response >>>", response);
                            if (response.responseType === "success") {
                                self.$toastr.success(response.msg, "", {});
                            } else {
                                self.$toastr.error(response.msg, "", {});
                                self.errors = response.msg;
                            }
                            self.clearForm();
                            self.editContactOpen = false;
                        } else {
                            console.log("error", error);
                        }
                    });
                } else {
                    console.log('not-success', this.validation)
                }
            })
        },
        fetchContentList() {
            let self = this;
            http.get("/frontend/contacts/get", {}, (error, response) => {
                console.log('fetchContentList:::', response);
                if (response.status === 'success') {
                    //self.contactList = response.data;
                    console.log('>>> response::: ', response);
                    /* let contactFilterData = response.data.map((item) => {
                        return { "_id": item._id, "user_id": item.user_id, "email": item.email, "name": item.name, "phone": item.phone, "whatsapp": item.whatsapp };
                    });
                    console.log('>>> contactFilterData::: ', contactFilterData);
                    self.contactList = contactFilterData; */
                    self.contactList = response.data;
                }
            });
        },

        openModal(image) {

        },
        getTabData(tabIndex, newTab, oldTab) {
            console.log('# tabs:', tabIndex, newTab.title, oldTab.title);
            //this.fetchContentList();
            this.curTab = newTab.title;
        },
    }
}
</script>
<style scoped>
.tab-border {
    border: 1px solid #c3c3c3;
}

.cat-compo {
    padding: 0 10rem;
}

/* -------- */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding: 20px;
}

.thumbnail-scroll {
    max-height: 70vh;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
    padding-right: 10px;
}

.thumb-card {
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    color: white;
}

.thumb-card:hover {
    transform: scale(1.03);
}

.thumbnail {
    width: 100%;
    height: 140px;
    object-fit: cover;
}

.thumb-card-body {
    padding: 10px;
}

.title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
}

.source {
    font-size: 12px;
    color: #aaa;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 90vw;
    max-height: 90vh;
    text-align: center;
    position: relative;
    width: fit-content;
}

.modal-img {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
}

.modal-title {
    font-weight: bold;
    margin-top: 10px;
}

.modal-source {
    color: gray;
    font-size: 14px;
}

.close-btn {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 24px;
    cursor: pointer;
}

/* Nav Button */
.card-actions {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.btn {
    padding: 4px 10px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.btn.edit {
    background-color: #007bff;
}

.btn.mail {
    background-color: #ffffff;
    border: 1px solid #00bd3a;
}

.btn.delete {
    background-color: #dc3545;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
}

.custom-table thead,
.custom-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.custom-table tbody {
    display: block;
    /* height: 165px; */
    overflow-y: auto;
}

.btn-edit {
    padding: 2px 5px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    /* color: white; */
}
</style>


// WEBPACK FOOTER //
// src/views/partners/Contacts.vue